(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bv-abo-toggle"] && !Shopify.designMode) return;
  try {
    (function(){
    function findForm(el){
      var scope = el.closest('[id^="ProductInformation"]') || el.closest('.shopify-section') || document;
      return scope.querySelector('form[action*="/cart/add"]') || scope.querySelector('form.shopify-product-form') || document.querySelector('form[action*="/cart/add"]');
    }
    function ensureInput(form){
      if(!form) return null;
      var inp = form.querySelector('input[name="selling_plan"][data-bv-abo]');
      if(!inp){
        inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'selling_plan'; inp.setAttribute('data-bv-abo','1');
        inp.disabled = true;
        form.appendChild(inp);
      }
      return inp;
    }
    function apply(sel){
      var planId = sel.getAttribute('data-plan-id');
      var inp = ensureInput(findForm(sel));
      var aboInput = sel.querySelector('[data-bv-opt="abo"] input');
      var abo = aboInput && aboInput.checked;
      if(inp){
        if(abo){ inp.disabled = false; inp.value = planId; }
        else { inp.disabled = true; inp.value = ''; }
      }
      sel.querySelectorAll('.bv-abosel__opt').forEach(function(o){
        var r = o.querySelector('input'); o.classList.toggle('is-active', !!(r && r.checked));
      });
    }
    function init(sel){
      if(sel.dataset.bvReady){ apply(sel); return; }
      sel.dataset.bvReady = '1';
      sel.addEventListener('change', function(){ apply(sel); });
      apply(sel);
      var form = findForm(sel);
      if(form){
        try {
          var mo = new MutationObserver(function(){ apply(sel); });
          mo.observe(form, { childList:true, subtree:true });
        } catch(e){}
      }
    }
    function boot(root){ (root||document).querySelectorAll('[data-bv-abosel]').forEach(init); }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ boot(); }); } else { boot(); }
    document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bv-audio"] && !Shopify.designMode) return;
  try {
    (function(){
    function fmt(s){ s=Math.max(0,Math.floor(s||0)); return Math.floor(s/60)+':'+String(s%60).padStart(2,'0'); }
    function init(root){
      if(root.dataset.bvAudioReady) return; root.dataset.bvAudioReady='1';
      var a=root.querySelector('.bv-audio__el'), btn=root.querySelector('.bv-audio__btn'),
          mask=root.querySelector('.bv-audio__mask'), wave=root.querySelector('.bv-audio__wave'),
          cur=root.querySelector('.bv-audio__cur'), tot=root.querySelector('.bv-audio__tot'),
          play=root.querySelector('.bv-audio__ic-play'), pause=root.querySelector('.bv-audio__ic-pause');
      if(!a||!btn) return;
      function prog(){ if(a.duration){ mask.style.width=(100-(a.currentTime/a.duration*100))+'%'; } }
      btn.addEventListener('click',function(){ if(a.paused){ a.play().catch(function(){}); } else { a.pause(); } });
      a.addEventListener('play',function(){ play.style.display='none'; pause.style.display=''; btn.setAttribute('aria-label','Pausieren'); });
      a.addEventListener('pause',function(){ play.style.display=''; pause.style.display='none'; btn.setAttribute('aria-label','Abspielen'); });
      a.addEventListener('timeupdate',function(){ prog(); cur.textContent=fmt(a.currentTime); });
      a.addEventListener('loadedmetadata',function(){ tot.textContent=fmt(a.duration); });
      a.addEventListener('ended',function(){ mask.style.width='100%'; cur.textContent='0:00'; });
      wave.addEventListener('click',function(e){ if(!a.duration) return; var r=wave.getBoundingClientRect(); a.currentTime=(e.clientX-r.left)/r.width*a.duration; prog(); });
    }
    function boot(){ document.querySelectorAll('.bv-audio').forEach(init); }
    document.addEventListener('DOMContentLoaded',boot); boot();
    document.addEventListener('shopify:section:load',boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bv-dhdl-testimonial"] && !Shopify.designMode) return;
  try {
    (function(){
    if(window.__bvDhdlWired) return; window.__bvDhdlWired = true;
    function open(card){
      var ov=document.createElement('div'); ov.className='bv-dhdl-ov'; ov.setAttribute('role','dialog'); ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-label','Video: Ralf Dümmel über BeoVita');
      var hd=card.getAttribute('data-src-hd'), sd=card.getAttribute('data-src-sd'), poster=card.getAttribute('data-poster');
      var html='<div class="bv-dhdl-ov__box"><button type="button" class="bv-dhdl-ov__close" aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
        + '<video controls playsinline preload="auto" poster="'+(poster||'')+'">'
        + (hd?'<source src="'+hd+'" type="video/mp4">':'')
        + (sd?'<source src="'+sd+'" type="video/mp4">':'')
        + '</video></div>';
      ov.innerHTML=html;
      document.body.appendChild(ov); document.body.style.overflow='hidden';
      var vid=ov.querySelector('video');
      try{ var pr=vid.play(); if(pr&&pr.catch) pr.catch(function(){}); }catch(e){}
      function close(){ try{ vid.pause(); }catch(e){} ov.remove(); document.body.style.overflow=''; document.removeEventListener('keydown',onKey); }
      function onKey(e){ if(e.key==='Escape') close(); }
      ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
      ov.querySelector('.bv-dhdl-ov__close').addEventListener('click',close);
      document.addEventListener('keydown',onKey);
    }
    document.addEventListener('click',function(e){
      var card=e.target.closest && e.target.closest('[data-bv-dhdl-open]');
      if(card){ e.preventDefault(); open(card); }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
